import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

import {
  bodyLineHeight,
  bodyFontSizeMapping,
} from "@/view/constants/styles/accessibleFontSizeMapping/accessibleFontSizeMapping.style";
const { ui } = constants.colors;

export const bannerCss = {
  color: ui.white[100],
  backgroundColor: ui.neutral[600],
  borderRadius: "10px",
  padding: "1em",
  marginBottom: ".5em",
  display: "flex",
  alignItems: "flex-start",
  columnGap: "1em",
};

export const cardCss: CSSObject = {
  padding: "1.56em",
  width: "100%",
  userSelect: "none",
  fontWeight: "normal",
};

const leftMarginCss = {
  marginLeft: "auto",
};

export const checkCircleFilledSvgCss = {
  flexShrink: 0,
  circle: {
    stroke: "none",
    fill: ui.green[700],
  },
  ...leftMarginCss,
};

export const closeCircleFilledSvgCss = {
  flexShrink: 0,
  circle: {
    stroke: "none",
    fill: ui.neutral[500],
  },
  ...leftMarginCss,
};

export const infoCircleHollowSvgCss = {
  flexShrink: 0,
  circle: {
    stroke: ui.white[100],
  },
  path: {
    stroke: ui.white[100],
  },
};

export const optionTextCss = ({
  currentFontSize = bodyFontSizeMapping.small,
  isWrongAnswerVisible = false,
}: {
  currentFontSize: string;
  isWrongAnswerVisible: boolean;
}) => ({
  textAlign: "left" as const,
  display: "flex",
  alignItems: "center",
  gap: "1em",
  lineHeight: bodyLineHeight,
  fontSize:
    bodyFontSizeMapping[currentFontSize as keyof typeof bodyFontSizeMapping],
  "& span:nth-of-type(1)": {
    color: isWrongAnswerVisible ? ui.neutral[500] : ui.neutral[700],
    fontWeight: "bold",
  },
  ...(isWrongAnswerVisible
    ? {
        "& span:nth-of-type(2)": {
          textDecoration: "line-through",
          color: ui.neutral[500],
        },
      }
    : {}),
});

export const optionBtnCss = ({ isSelected }: { isSelected: boolean }) => ({
  root: {
    gap: "1em",
    fontFamily: "Circular",
    display: "flex",
    justifyContent: "flex-start",
    padding: "0.25em 1em 0.25em 0.25em",
    border: 0,
    borderRadius: "4px",
    columnGap: "0.5em",
    lineHeight: bodyLineHeight,
    /* display horizontal blue bar next to unsubmitted selected answer  */
    "::before": {
      content: '""',
      display: "inline-block",
      width: "4px",
      height: "40px",
      borderRadius: "2px",
      background: isSelected ? ui.core[700] : "transparent",
    },
    // Maintain readability of disabled options
    "&[disabled], :hover[disabled], :focus[disabled]": {
      opacity: "1",
    },
  },
});

export const isIncorrectBtnCss = {
  ...optionBtnCss({
    isSelected: false,
  }),
};

export const isCorrectBtnCss = {
  root: {
    ...optionBtnCss({ isSelected: false }).root,

    backgroundColor: "#DFF3EF",

    ":hover, &[disabled], :hover[disabled], :focus[disabled]": {
      opacity: "1",
      backgroundColor: "#DFF3EF",
    },
  },
};

export const answersCss = {
  margin: "1.125em 0",
  paddingInlineStart: "0",
  li: {
    display: "flex",
    marginInlineStart: "0",
    "&:not(:last-child)": {
      paddingBottom: "1.125em",
    },
  },
};

export const answerButtonWrapperCss = {
  width: "100%",
};
